import { apiFetchInvitedAgentUsed, apiInviteAgentBind } from '@/api/invite'

export function hasInvitedAgentInfo(resData) {
  if (!resData || typeof resData !== 'object' || resData.error) return false
  return !!(resData.nickname || resData.uid)
}

export function checkInvitedAgentBeforeBind(invitedCode) {
  return apiFetchInvitedAgentUsed(invitedCode)
    .then((res) => {
      if (hasInvitedAgentInfo(res)) {
        console.log('🚀 ~ true')
        return { needConfirm: true, agentInfo: res }
      }
      console.log('🚀 ~ false')
      return { needConfirm: false }
    })
    .catch(() => ({ needConfirm: false }))
}

export function submitAgentBind(inviteCode) {
  return apiInviteAgentBind(inviteCode)
}
